import { Component } from '@angular/core';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  toast$ = this.alertService.toast$;
  duration = this.alertService.duration;

  // used to force DOM re-creation
  progressKey = 0;

  constructor(private alertService: AlertService) {
    this.toast$.subscribe(toast => {
      if (toast) {
        this.progressKey++; // retrigger animation
      }
    });
  }

  icon(type: string) {
    return type === 'success' ? '✓' : '✕';
  }

  close() {
    this.alertService.hide();
  }
}
